import { Box } from '@material-ui/core';
import React, { FC } from 'react';

const BonusDrawListTitle: FC = () => {
  return (
    <Box marginTop='2em'>
      <div className='active-prizes-container'>Bonus Draw Management</div>
    </Box>
  );
};

export default BonusDrawListTitle;
